import { EventTypes } from '../types';
import { buildGrafanaEvent } from './base';

const { applicationSubmit } = EventTypes;

export const GrafanaEvents = {
    [applicationSubmit]: buildGrafanaEvent(applicationSubmit),
};
